import { ApplicationState } from '../reducers';
import { IWizardState as NewWizardState } from '../reducers/newWizard';
import { IWizardState as IllegibleWizardState } from '../reducers/illegibleWizard';
import { IWizardState as TransferWizardState } from '../reducers/transferWizard';

export const getActiveWizard = (state: ApplicationState) => {
    const newWizard = state.newWizard as NewWizardState;
    const illWizard = state.illegibleWizard as IllegibleWizardState;
    const transferWizard = (state as any).transferWizard as TransferWizardState;
    if (newWizard.step) {
        return 'new';
    }
    if (illWizard.step) {
        return 'illegible';
    }
    if (transferWizard && transferWizard.step) {
        return 'transfer';
    }
    return undefined;
}

export const getLSV = (state: ApplicationState) => {
    try {
        const { newWizard } = state;
        const { lsv } = newWizard as NewWizardState;
        return lsv;
    }
    catch {
        return undefined;
    }
};

export const getNewWizard = (state: ApplicationState) => state.newWizard;
export const getIllegibleWizard = (state: ApplicationState) => state.illegibleWizard;

export const getLookupData = (state: ApplicationState) => {
    const { illegibleWizard } = state;
    const { regNumber, lastName, email } = illegibleWizard;
    return {
        regNumber,
        lastName,
        email
    }
}

export const shouldTakePayment = (state: ApplicationState) => {
    const { newWizard } = state;
    const { paymentMethod } = newWizard;
    return paymentMethod === 'OL';
};

export const getAlreadyConfirmed = (state: ApplicationState) => {
    const newWizard = state.newWizard as NewWizardState;
    const illWizard = state.illegibleWizard as IllegibleWizardState;
    const transferWizard = (state as any).transferWizard as TransferWizardState;
    const { step: newStep } = newWizard;
    const { step: illStep } = illWizard;
    const transferStep = transferWizard ? transferWizard.step : undefined;
    
    return !!((newStep && newStep == 9) || (illStep && illStep == 7) || (transferStep && transferStep == 5));
}

export const getActiveStep = (state: ApplicationState) => {
    const newWizard = state.newWizard as NewWizardState;
    const illWizard = state.illegibleWizard as IllegibleWizardState;
    const transferWizard = (state as any).transferWizard as TransferWizardState;
    const { step: newStep } = newWizard;
    const { step: illStep } = illWizard;
    const transferStep = transferWizard ? transferWizard.step : undefined;

    return newStep || illStep || transferStep;
}

// export const getLSVID = (state: ApplicationState) => {
//     try {
//         const { id } = getLSV(state);
//         return lsv;
//     }
//     catch {
//         return null;
//     }
// };
